export default __webpack_public_path__ + "static/media/logoBrand.effb82c5.svg";